module.exports = __webpack_public_path__ + "img/7_150.e2d8dd43.png";